import React, { useState, useCallback, useEffect, useContext, useMemo } from "react";
import qs from "qs";
import { useStaticQuery, graphql } from "gatsby";
import UserContext from "../components/context/user";
import useClickOut from "../hooks/use-click-out";
import {
  getAccountUrl,
  getCommunityUrl,
  getOrdersUrl,
  hasCommerceCloud,
  startUserLogin,
} from "../utility/commerce-cloud";
import UserNew from "../icons/sprite_black-user-new.svg";
import classNames from "classnames";

const SALESFORCE_BASE_URL = process.env.GATSBY_SALESFORCE_BASE_URL;
const client_id = process.env.GATSBY_SALESFORCE_CLIENT_ID;
const redirect_uri = process.env.GATSBY_REDIRECT_URI;

const User = () => {
  const [user, setUser] = useState(false);
  const toggleUser = useCallback(() => setUser((value) => !value), []);
  const userRef = useClickOut(user, setUser);

  const { userData, logout } = useContext(UserContext);

  const { labelManagerLabels } = useStaticQuery(
    graphql`
      query {
        labelManagerLabels: labelManagerLabels {
          user
          login
          logout
          myAccount
          myCommunity
          myOrders
        }
      }
    `
  );

  const userLogin = async () => {
    if (hasCommerceCloud) {
      startUserLogin();
    } else {
      const sfLoginUrl = `${SALESFORCE_BASE_URL}/services/oauth2/authorize/expid_serviceRegHoover?${qs.stringify(
        {
          client_id,
          prompt: "login",
          response_type: "code",
          state: window.location.href,
          redirect_uri: redirect_uri,
        }
      )}`;
      window.location.href = sfLoginUrl;
    }
  };

  useEffect(() => {
    if (!userData) {
      setUser(false);
    }
  }, [userData]);

  const accountUrl = useMemo(() => {
    return hasCommerceCloud
      ? getAccountUrl(userData)
      : `${userData?.iss}${userData?.profile?.substring(userData?.profile?.lastIndexOf("/"))}`;
  }, [userData]);

  const communityUrl = useMemo(() => {
    return hasCommerceCloud ? getCommunityUrl() : `${userData?.iss}`;
  }, [userData]);

  const ordersUrl = useMemo(() => {
    return hasCommerceCloud ? getOrdersUrl() : null;
  }, []);

  return (
    <>
       <div className={classNames("header-tools__tool--ciam", (userData && "header-tools__tool--ciam-logged"))}>
        {userData ? (
          <button
            className="header-tools__tool"
            onClick={toggleUser}
            aria-label={labelManagerLabels.user}
          >
            {userData.given_name.charAt(0) + userData.family_name.charAt(0)}
          </button>
        ) : userData !== undefined ? (
          <button
            className="header-tools__tool"
            onClick={userLogin}
            aria-label={labelManagerLabels.login}
          >
            <UserNew className="user" />
          </button>
        ) : (
          <div className="header-tools__tool">
            <UserNew className="user" />
          </div>
        )}
        <ul ref={userRef} className={classNames("header-tools__children", !user && "d-none")}>
          {userData && (
            <>
              <li className="header-tools__child">
                <a
                  href={accountUrl}
                  target="_blank"
                  className="header-tools__child-label"
                  rel="noopener noreferrer"
                >
                  {labelManagerLabels.myAccount}
                </a>
              </li>
              <li className="header-tools__child">
                <a
                  href={communityUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header-tools__child-label"
                >
                  {labelManagerLabels.myCommunity}
                </a>
              </li>
              {ordersUrl && (
                <li className="header-tools__child">
                  <a
                    href={ordersUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="header-tools__child-label"
                  >
                    {labelManagerLabels.myOrders}
                  </a>
                </li>
              )}
              <li className="header-tools__child">
                <button className="header-tools__child-label" onClick={logout}>
                  {labelManagerLabels.logout}
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
};

export default User;
